// Global
import { useEffect, useState, } from 'react';
export const useTransitionOnRender = ({ container, isDisplayed, }) => {
    const [hasMounted, setHasMounted,] = useState(false);
    const [shouldRender, setShouldRender,] = useState(false);
    const [shouldAnimate, setShouldAnimate,] = useState(false);
    const renderComponent = () => {
        setShouldRender(true);
        // Ensure that we've rendered before we trigger the
        // 'open' styles so they can animate in
        window.requestAnimationFrame(() => {
            setShouldAnimate(true);
        });
    };
    /**
     * Begins animating out the component. Will complete fully
     * once the corresponding `handleTransitionEnd` callback has triggered.
     */
    const unmountComponent = () => {
        // Wait until thread is ready to prevent attempting to animate
        // during heavy processing
        window.requestAnimationFrame(() => {
            setShouldAnimate(false);
        });
    };
    useEffect(() => {
        if (hasMounted) {
            isDisplayed ? renderComponent() : unmountComponent();
        }
    }, [
        isDisplayed,
        hasMounted,
    ]);
    useEffect(() => {
        setHasMounted(true);
    }, []);
    const handleTransitionEnd = (event) => {
        // Ensure we aren't picking up a bubbling transition end from a child element
        if (container && event.target === container.current) {
            if (!isDisplayed) {
                setShouldRender(false);
            }
        }
    };
    return {
        handleTransitionEnd,
        shouldAnimate,
        shouldRender,
    };
};
